__turbopack_context__.v({
  "bio_section": "_-module__c8Qfvq__bio_section",
  "container": "_-module__c8Qfvq__container",
  "hover__target": "_-module__c8Qfvq__hover__target",
  "hover__trigger": "_-module__c8Qfvq__hover__trigger",
  "hover_underline_animation": "_-module__c8Qfvq__hover_underline_animation",
  "scrollbar": "_-module__c8Qfvq__scrollbar",
  "waitlist_container": "_-module__c8Qfvq__waitlist_container",
});
